import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import RFQModal from "../components/RFQModal";



import {
  LuShare2,
  LuHeadphones,
  LuChartNoAxesCombined,
  LuZap,
  LuMessagesSquare,
  LuShield,
  LuCheck,
} from "react-icons/lu";

const BusinessOutsource = () => {
  const [show, setShow] = useState(false);

  return (
    <div id="business-outsource">
      <Navbar />

      {/* HERO */}

      <section className="bpo-intro">
        <div className="bpo-overlay">
          <div className="bpo-hero-content">
            <div className="hero-badge">
              LIVE OPERATIONS ACROSS WEST AFRICA & BEYOND
            </div>

            <h1>
              30.5M+ customer interactions<wbr /> a year. Zero guesswork.
            </h1>

            <p>
              Outcess runs the contact centers, data processing, and back-office
              operations behind some of the region's most demanding businesses —
              so you can scale without adding headcount or risk.
            </p>

            <button className="ccsnl-btn" onCdivck={() => setShow(true)}>
              Book a Demo
            </button>
          </div>
        </div>
      </section>

      <RFQModal show={show} setShow={setShow} />

      
        {/* SERVICES */}

        <section className="bpo-service">
          <div className="container bpo-services ">
            <div className="services-left">
              <h2>
                Three services.
                <br />
                <span>One operations partner.</span>
              </h2>

              <p>
                We plug into your business at the layer you need end-to-end
                managed, channel-specific, or purely data. No lock-in to a scope
                you didn't ask for.
              </p>
            </div>

            <div className="service-right">
              <div className="service-right-item">
                <h5>
                  <LuShare2 />
                  Managed Services
                </h5>

                <p>
                  Your IT, customer service, and sales operations running
                  without you having to babysit them. We keep the lights on so
                  your team can focus on growth
                </p>
              </div>

              <div className="service-right-item">
                <h5>
                  <LuHeadphones />
                  Contact Center Outsourcing
                </h5>

                <p>
                  Every inbound call, outbound campaign, and telemarketing push
                  handled by a multipurpose contact center built to flex with
                  your volume.
                </p>
              </div>

              <div className="service-right-item">
                <h5>
                  <LuChartNoAxesCombined />
                  Data Processing
                </h5>

                <p>
                  Turn raw data into decisions. We capture and analyze
                  information strategically, so your outsourcing goals actually
                  move the needle
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* AI */}

        <section className="bpo-ai">
          <div className="container bpo-ai-content">
            <div className="ai-content">
              <div className="ai-content-head">
                <h2>Smarter AI, backed by real people.</h2>

                <p>
                  Outcess pairs AI-driven chatbots, virtual assistants, and
                  predictive analytics with real human agents — automating the
                  routine so your team can focus on what actually needs a
                  person.
                </p>
              </div>

              <div className="ai-feature">
                <LuZap />
                <div>
                  <h5>Faster resolution</h5>
                  <p>Routine requests handled instantly by AI.</p>
                </div>
              </div>

              <div className="ai-feature">
                <LuMessagesSquare />
                <div>
                  <h5>Smarter conversations</h5>
                  <p>Sentiment analysis flags what needs urgent attention</p>
                </div>
              </div>

              <div className="ai-feature">
                <LuShield />
                <div>
                  <h5>Lower cost, same trust</h5>
                  <p>Automation where it helps, humans where it matters.</p>
                </div>
              </div>
            </div>

            <div className="ai-image"></div>
          </div>
        </section>

        {/* BENEFITS */}

        <section className="bpo-benefits">
          <div className="container  bpo-benefit">
            <div className="benefit-header">
              <h2>
                Outsource what slows you down.
                <br />
                <span>Keep what makes you, you.</span>
              </h2>

              <p>
                Running a business means juggling core work and the operational
                weight around it
                <br /> payroll, support, compliance, data. BPO takes the weight
                off, so you can focus on what
                <br /> only your team can do.
              </p>
            </div>

            <div className="benefit-grid">
              <div className="benefit-card">
                <LuHeadphones />

                <h5>Efficiency</h5>

                <p>
                  Fewer manual processes, more consistent output, and measurable
                  gains in productivity.
                </p>
              </div>

              <div className="benefit-card">
                <LuChartNoAxesCombined />

                <h5>Cost</h5>

                <p>
                  Free up capital currently tied to operations and reinvest it
                  in growth and innovation.
                </p>
              </div>

              <div className="benefit-card">
                <LuShield />

            <h5>Predictability</h5>

                <p>
                  Steadier outcomes, fewer surprises, and a business that's more
                  resilient when conditions change.
                </p>
              </div>
              <div className="benefit-grid-button">
                <button className="ccsnl-btn" onCdivck={() => setShow(true)}>
                  Book a Demo
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* CONTACT CENTER */}

        <section className="contact-center">
          <div className="container contact-center-container">
            <div className="contact-image "></div>

            <div className="contact-content ">
              <h2>Contact Center Outsourcing</h2>

              <p>
                Outcess runs on custom CRM, giving you enterprise-grade contact
            center capability without the enterprise overhead.
              </p>

              <div className="contact-center-feature">
                <LuCheck />
                <div>
                  <h5>Unified queuing</h5>
                  <p>Across every agent, domestic and global</p>
                </div>
              </div>

              <div className="contact-center-feature">
                <LuCheck />
                <div>
                  <h5>Pay-as-you-go</h5>
                  <p>
                    Turn fixed IT cost (CAPEX) into flexible operating spend
                    (OPEX).
                  </p>
                </div>
              </div>

              <div className="contact-center-feature">
                <LuCheck />
                <div>
                  <h5> Smart routing</h5>
                  <p>
                    Interactive voice response (IVR) and computer telephony
                    integration (CTI).
                  </p>
                </div>
              </div>

              <div className="contact-center-feature">
                <LuCheck />
                <div>
                  <h5>Automated dialing</h5>
                  <p>Distribution for outbound campaigns at scale.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
    
      {/* CTA */}
      <section className="bpo-cta">
        
          <div>
            <h2>Talk to an outsourcing specialist.</h2>

            <p>
              Tell us what's slowing your team down. We'll show you what a
              tailored operations model looks like.
            </p>
          </div>

          <button className="ccsnl-btn" onClick={() => setShow(true)}>
            Book a Demo
          </button>
       
      </section>
      <Footer />
    </div>
  );
};

export default BusinessOutsource;
